import { RegularDrawdownClient } from "../../../../../../Wrap/Api/Drawdown/RegularDrawdown";
import { ServiceValidationError } from "../../../../../../Wrap/Core/DataTypes/ServiceValidation/ServiceValidationError";

export class CancelRegularCrystallisationAction{
  public static cancelRegularCrystallisation(hierarchyId: string, onSuccess: (result: ServiceValidationError[],) => void, onError?: (error) => void) {
    const client = new RegularDrawdownClient();
    const promise = client.delete(hierarchyId);
    promise.onSuccess((result) => {onSuccess(result)});
    promise.onError((error) => {if (onError) {onError(error)}});
  }
}
